import { render, staticRenderFns } from "./SelectSedeAll.vue?vue&type=template&id=4ba421b0&"
import script from "./SelectSedeAll.vue?vue&type=script&lang=js&"
export * from "./SelectSedeAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports